export default "__VITE_PUBLIC_ASSET__19f624f4__"